import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import Fullscreen from 'react-fullscreen-crossbrowser';
import initReactFastclick from 'react-fastclick';
import Header from '../components/global/header/Header';
import Loader from '../components/global/Loader';
import Nav from '../components/global/Nav';
import Footer from '../components/global/Footer';
import Menu from '../components/sections/menu/Menu';
import Before from '../components/sections/before/Before';
import Lc from '../components/sections/lc/Lc';
import Uc from '../components/sections/uc/Uc';
import Num from '../components/sections/num/Num';
import Words from '../components/sections/words/Words';
import Own from '../components/sections/own/Own';
import { isIOS, isNotIOS } from '../actions/ios';
import { fullScreen, regularScreen } from '../actions/fullscreen';
import { shadowSize } from '../utils/utils';


var viewportUnitsBuggyfill = require('viewport-units-buggyfill');

export class AppRouter extends React.Component {
	onFullscreenChange = () => {
		const fsArray = [
			document.fullscreenElement,
			document.webkitFullscreenElement,
			document.msFullscreenElement,
			document.mozFullscreenElement
		];
       	let fsTotal = 0;

        for (let i = 0; i < 4; i++) {

            if (fsArray[i] === null || fsArray[i] === undefined) {

                fsTotal++;
            }
        }

        if (fsTotal === 4) {
        	this.props.regularScreen();
        }
	}
	componentDidMount() {
		if (navigator && navigator.userAgent && navigator.userAgent !== null) {

            var strUserAgent = navigator.userAgent.toLowerCase(),
                arrMatches = strUserAgent.match(/(iphone|ipad)/);

            if (arrMatches) {
            	this.props.isIOS();
            }
            else {
            	this.props.isNotIOS();
            }
        }

        $(document).bind(
	    	'touchmove',
	    		function(e) {
	    			e.preventDefault();
	    		}
		);

		$(window).on('resize.shadow', function() {
            shadowSize();
        });

        shadowSize();

		viewportUnitsBuggyfill.init();
		initReactFastclick();
  	}
	render() {
    	return (
			<HashRouter>
				<Fullscreen enabled={this.props.fullscreen.fullscreen} onChange={this.onFullscreenChange}>
					<div id="container">
						<Loader />
						<Header />
						<main>
						    <div id="content">
						    	<Route path="/" render={ ( props ) => ( props.location.pathname !== "/") && <Nav /> } />
						    	<Switch>
						    		<Route path="/" component={Menu} exact={true} />
						    		<Route path="/before" component={Before} exact={true} />
		                			<Route path="/lowercase" component={Lc} exact={true} />
		                			<Route path="/uppercase" component={Uc} exact={true} />
		                			<Route path="/num" component={Num} exact={true} />
		                			<Route path="/words" component={Words} exact={true} />
		                			<Route path="/own" component={Own} exact={true} />
						    	</Switch>
						    	<Footer />
						    </div>
						</main>
					</div>
				</Fullscreen>
		  	</HashRouter>
		)
  	}
};

const mapStateToProps = function(state){
	return {
		fullscreen: state.fullscreen,
		ios: state.ios
	}
}

const mapDispatchToProps = (dispatch) => ({
	regularScreen: () => dispatch(regularScreen()),
	isIOS: () => dispatch(isIOS()),
	isNotIOS: () => dispatch(isNotIOS())
});

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter);



// WEBPACK FOOTER //
// ./src/routers/AppRouter.js